import {
  type InferOutput,
  number,
  object,
  optional,
  picklist,
  string
} from 'valibot'

export const PlanSlotsSearchSchema = object({
  dcId: optional(number()),
  status: optional(picklist(['active', 'inactive', 'all'])),
  partnerId: optional(number()),
  subPartnerId: optional(number()),
  truckName: optional(string()),
  page: optional(number()),
  take: optional(number())
})

export type PlanSlotsSearch = InferOutput<typeof PlanSlotsSearchSchema>
